(function () {
    "use strict";

    angular.module("app").component("cbeButton", {
        transclude: true,
        template: `<button class="btn btn-default" ng-click="$ctrl.Open()"><span class="fa fa-globe"></span> <ng-transclude></ng-transclude></button>`,
        bindings: { reference: "=" },
        controller: CbeButtonController
    });

    CbeButtonController.$inject = ["HabilNavigator"];
    function CbeButtonController(HabilNavigator) {
        const vm = this;

        vm.Open = function () {
            if (!vm.reference)
                return;

            HabilNavigator.OpenKboSearchNumberInTab(vm.reference);
        };
    }
})();